import { render, staticRenderFns } from "./bar-loader.vue?vue&type=template&id=172e2aaf&scoped=true&"
import script from "./bar-loader.vue?vue&type=script&lang=js&"
export * from "./bar-loader.vue?vue&type=script&lang=js&"
import style0 from "./bar-loader.vue?vue&type=style&index=0&id=172e2aaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e2aaf",
  null
  
)

component.options.__file = "bar-loader.vue"
export default component.exports